import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import axios from 'axios';
import Tabs from './components/Tabs';
// Benutze diese SummaryLiist, wenn keine Lautsprecherausgabe stattfinden soll
//import SummaryList from './components/SummaryList';
import CountdownTimer from './components/CountdownTimer';
import SummaryList from './components/SummaryListWithTTS';
import LegalNotice from './components/LegalNotice';
import PrivacyPolicy from './components/PrivacyPolicy';
import CookieBanner from './components/CookieBanner';

function Home() {
  const [dates, setDates] = useState([]);
  const [selected, setSelected] = useState('');
  const [summaries, setSummaries] = useState({});
  const [loadingDates, setLoadingDates] = useState(true);
  const [loadingSummaries, setLoadingSummaries] = useState(false);

  useEffect(() => {
    setLoadingDates(true);
    axios.get('/dates')
      .then(r => {
        setDates(r.data);
        if (r.data.length > 0) setSelected(r.data[0]);
      })
      .finally(() => setLoadingDates(false));
  }, []);

  useEffect(() => {
    if (!selected) return;
    setLoadingSummaries(true);
    axios.get(`/summaries/${selected}`)
      .then(r => setSummaries(r.data))
      .finally(() => setLoadingSummaries(false));
  }, [selected]);

  return (
    // dark:bg und bg setzen
    <div className="min-h-screen bg-gray-100 dark:bg-gray-900 flex flex-col">
      <header className="bg-white dark:bg-gray-800 shadow">
        <div className="max-w-4xl mx-auto py-6 px-4 flex flex-col items-center text-center">
          <h1 className="text-3xl font-bold text-gray-900 dark:text-gray-100">
          Today's news – researched & summarized by AI
          </h1>
          {/* Countdown bis zum nächsten Lauf (hier 20:00) */}
          <div className="mt-2">
            <CountdownTimer scheduleHour={2} scheduleMinute={0} />
          </div>
        </div>
      </header>

      {loadingDates ? (
        <div className="p-6 text-center text-gray-700 dark:text-gray-300">Loading avaiable data...</div>
      ) : (
        <Tabs dates={dates} selected={selected} onSelect={setSelected} />
      )}

      <main className="flex-grow">
        {loadingSummaries ? (
          <div className="p-6 text-center text-gray-700 dark:text-gray-300">Loadinng summaries...</div>
        ) : (
          <SummaryList summaries={summaries} />
        )}
      </main>

      <footer className="text-center py-4 text-sm text-gray-500 dark:text-gray-400">
        <div>
          © {new Date().getFullYear()} DailyNewsSummarizer
        </div>
        <p className="mt-2 text-xs italic text-gray-600 dark:text-gray-500 max-w-2xl mx-auto">
          Please note that this summary is intended as a broad overview. The content is automatically researched and summarized by AI from online sources, so it may be incomplete, outdated, contain errors or false information. The creator accepts no liability for any inaccuracies or misinformation that may arise. When in doubt, please verify the information with the original sources.
      </p>
      <div className="mt-3 flex justify-center space-x-4">
          <Link to="/legal" className="hover:underline">Legal Notice</Link>
          <Link to="/privacy" className="hover:underline">Privacy Policy</Link>
        </div>
      </footer>

    </div>
  );
}

export default function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/legal" element={<LegalNotice />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
      </Routes>
      {/* Cookie-Banner auf allen Seiten */}
      <CookieBanner />
    </Router>
  );
}